
/**
 * This mixin allows The Scenes Content components to
 * automatically have their data synced with the manifests content nodes matching the id's
 */
const SceneContentComponentMixin = {


    props: {
        "contentId": { type: Number, default: -1},
        "useInlineData": { type: Boolean, default: false, required: false},
        "inlineData": {type: Object, default: function () { return {}}, required: false}
    },

    watch: { 
        contentId: function() {  this.setData(); }
    },

    created () {
        this.setData();
    },

    methods: {
        /**
         * Updates the components data with the content.data from the node in the manifest matching the contentId, 
         * if useInline data is true, the inlineData property defined in the component will be used instead.
         */
        setData() {

            if(this.useInlineData) {
                Object.keys(this.$data).forEach(k => {
                    if(this.inlineData.hasOwnProperty(k))
                    this.$data[k] = this.inlineData[k];
                })
            }
            else {

                var objData = JSON.parse(JSON.stringify(touchKit.PageManager.getContent(this.contentId).data));
                Object.keys(this.$data).forEach(k => {
                    if(objData.hasOwnProperty(k))
                    this.$data[k] = objData[k];
                })
            }
        },

        close () {
            this.$emit("close", this.contentId);
        }
    }
};